import { getRequest, postRequest, postRequestFile, putRequestFile } from "../../config/axiosConfig";

export const createBranch = async (formData) => {
  try {
    const response = await postRequestFile({
      url: process.env.REACT_APP_BASE_URL + "hospital-branch/create-branch",
      data: formData
    });

    if (response?.status === 201) {
      return {
        success: true,
        data: response,
        message: "branch created Successfully!",
      };
    } else {
       return {
      success: false,
      data: response,
    };
    }
   
  } catch (error) {
    return {
      success: false,
      data: null,
      message: "Invalid branch creation attempt.",
    };
  }
};

export const getAllBranch = async () => {
  try {
    const response = await getRequest({
      url: process.env.REACT_APP_BASE_URL + "hospital-branch/get-all-branch",
    });

    if (response?.status === 200) {
      return {
        success: true,
        data: response,
        message: "branch retrieved Successfully!",
      };
    }
    return {
      success: false,
      data: response,
    };
  } catch (error) {
    return {
      success: false,
      data: null,
      message: "Invalid branch retrival request.",
    };
  }
};



export const getBranchById = async ({ branch_id }) => {
  try {
    const response = await postRequest({
      url: process.env.REACT_APP_BASE_URL + "hospital-branch/get-branch-by-id",
      data: { id: branch_id },
    });

    if (response?.status === 200) {
      return {
        success: true,
        data: response,
      };
    }
    return {
      success: false,
      data: response,
    };
  } catch (error) {
    return {
      success: false,
      data: null,
      message: "Invalid roles retrival request.",
    };
  }
};

export const updateBranch = async (formData) => {
  try {
    const response = await putRequestFile({
      url: process.env.REACT_APP_BASE_URL + "hospital-branch/update-branch",
      data: formData
    });

    if (response?.status === 201) {
      return {
        success: true,
        data: response,
        message: "branch updated Successfully!",
      };
    }
    return {
      success: false,
      data: response,
    };
  } catch (error) {
    return {
      success: false,
      data: null,
      message: "Invalid branch update attempt.",
    };
  }
}